import { inViewFade, inViewFadeUp } from '@helpers/animate';
import brand from '@helpers/brand';
import { baseGrid } from '@helpers/grid';
import { Device, from, until } from '@helpers/media';
import { h3, subhead } from '@helpers/typography';
import styled from 'styled-components';
import SectionWrapper from '../SectionWrapper/SectionWrapper';
const Container = styled(SectionWrapper) `
  --itemGutter: 24px;

  background: var(--bgColor);
  color: var(--fgColor);
  overflow-x: hidden;
  padding-block: 64px;

  &[data-theme='light'] {
    --bgColor: ${brand.grey.grey1};
    --fgColor: ${brand.grey.grey6};
  }

  &[data-theme='mid'] {
    --bgColor: ${brand.grey.grey4};
    --fgColor: ${brand.white};
  }

  &[data-theme='dark'] {
    --bgColor: ${brand.grey.grey6};
    --fgColor: ${brand.white};
  }

  @media ${from(Device.DesktopSmall)} {
    --itemGutter: 40px;
  }
`;
const Inner = styled.div `
  ${baseGrid};
  row-gap: 24px;
  width: 100%;

  @media ${from(Device.TabletLarge)} {
    grid-template-rows: auto auto 1fr;
  }
`;
const ContentWrapper = styled.div `
  position: relative;
  display: flex;
  flex-direction: column;
  z-index: 2;

  @media ${until(Device.TabletLarge)} {
    grid-column: 1 / span 12;
    grid-row: 1;
  }

  @media ${from(Device.TabletLarge)} {
    grid-column: 1 / span 3;
    grid-row: 1;
  }
`;
const Title = styled.h2 `
  ${h3};

  ${inViewFadeUp({ delay: 0, duration: 0.3 })};
`;
const Content = styled.p `
  ${subhead};

  ${inViewFadeUp({ delay: 0.15, duration: 0.3 })};
`;
const CtaWrapper = styled.div `
  @media ${until(Device.TabletLarge)} {
    grid-column: 1 / span 12;
    grid-row: 4;
    justify-self: flex-end;
  }

  @media ${from(Device.TabletLarge)} {
    grid-column: 1 / span 3;
    grid-row: 3;
    margin-top: auto;
  }

  ${inViewFadeUp({ delay: 0.3, duration: 0.3 })};
`;
const CarouselWrapper = styled.div `
  clip-path: polygon(0% 0%, 100vw 0%, 100vw 100%, 0% 100%);
  grid-column: 1 / span 12;
  grid-row: 2;
  margin-top: 3rem;
  padding-right: 3rem;

  @media ${from(Device.TabletLarge)} {
    grid-column: 4 / span 9;
    grid-row: 1 / span 3;
    margin-top: 0;
  }

  ${inViewFade({ delay: 0, duration: 0.6 })};
`;
const Item = styled.li `
  display: block;
  flex: 0 0 calc(100% / var(--visibleItems));
  max-width: 100%;
  padding-right: var(--itemGutter);
`;
const ControlsWrapper = styled.div `
  display: flex;
  gap: 8px;
  user-select: none;

  @media ${until(Device.TabletLarge)} {
    gap: 8px;
    grid-column: 1 / span 12;
    grid-row: 3;
    justify-self: flex-end;
  }

  @media ${from(Device.TabletLarge)} {
    gap: 32px;
    grid-column: 1 / span 3;
    grid-row: 2;
  }

  ${inViewFadeUp({ delay: 0.3, duration: 0.3 })};
`;
const CardCarouselStyles = {
    CarouselWrapper,
    Container,
    Content,
    ContentWrapper,
    ControlsWrapper,
    CtaWrapper,
    Inner,
    Item,
    Title,
};
export default CardCarouselStyles;
